import React from "react";
import { useTranslation } from "react-i18next";

import { Badge, Tooltip, useColorModeValue } from "@chakra-ui/react";

const getStatusColorScheme = (status) => {
	switch (status) {
		case "incomplete":
			return "red";
		case "expired":
			return "red";
		case "warning":
			return "orange";
		case "empty":
			return "blue";
		default:
			return "green";
	}
};

export default function StatusBadge({ status, tooltipLabel }) {
	const { t } = useTranslation();

	return (
		<Tooltip
			label={tooltipLabel}
			hasArrow
			bg={useColorModeValue("white", "gray.800")}
			color={useColorModeValue("gray.900", "white")}
			p={3}
			borderRadius="md"
			boxShadow="lg"
			border="1px solid"
			borderColor={useColorModeValue("gray.200", "gray.600")}
		>
			<Badge colorScheme={getStatusColorScheme(status)} height="fit-content">
				{t(`table.${status}`)}
			</Badge>
		</Tooltip>
	);
}
